import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t" data-id="element-108">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-109">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-110">
          {/* Company Info */}
          <div data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/hYisivs9KHVbNKgWAv2Grq/420963685_924546946010783_2955376449317955242_n.jpg" alt="Materiales Brasil" className="h-12 w-auto mb-4" data-id="element-112" />
            <p className="text-gray-500 text-sm leading-relaxed mb-4" data-id="element-113">
              Tu ferretería de confianza en Caracas. Herramientas profesionales,
              cerrajería de calidad y materiales de construcción.
            </p>
            <div className="flex gap-3" data-id="element-114">
              <a href="#" className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 hover:bg-[#0056b3] hover:text-white transition-colors" data-id="element-115">
                <Facebook className="w-4 h-4" data-id="element-116" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 hover:bg-[#0056b3] hover:text-white transition-colors" data-id="element-117">
                <Instagram className="w-4 h-4" data-id="element-118" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-119">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-120">Enlaces</h3>
            <ul className="space-y-2 text-sm" data-id="element-121">
              <li data-id="element-122">
                <Link to="/catalogo" className="text-gray-500 hover:text-[#0056b3]" data-id="element-123">
                  Catálogo
                </Link>
              </li>
              <li data-id="element-124">
                <Link to="/servicios" className="text-gray-500 hover:text-[#0056b3]" data-id="element-125">
                  Servicios
                </Link>
              </li>
              <li data-id="element-126">
                <Link to="/nosotros" className="text-gray-500 hover:text-[#0056b3]" data-id="element-127">
                  Nosotros
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="/contacto" className="text-gray-500 hover:text-[#0056b3]" data-id="element-129">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-130">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-131">Categorías</h3>
            <ul className="space-y-2 text-sm" data-id="element-132">
              <li data-id="element-133">
                <Link to="/catalogo?cat=herramientas" className="text-gray-500 hover:text-[#0056b3]" data-id="element-134">
                  Herramientas Eléctricas
                </Link>
              </li>
              <li data-id="element-135">
                <Link to="/catalogo?cat=cerrajeria" className="text-gray-500 hover:text-[#0056b3]" data-id="element-136">
                  Cerrajería
                </Link>
              </li>
              <li data-id="element-137">
                <Link to="/catalogo?cat=plomeria" className="text-gray-500 hover:text-[#0056b3]" data-id="element-138">
                  Plomería
                </Link>
              </li>
              <li data-id="element-139">
                <Link to="/catalogo?cat=pintura" className="text-gray-500 hover:text-[#0056b3]" data-id="element-140">
                  Pintura
                </Link>
              </li>
              <li data-id="element-141">
                <Link to="/catalogo?cat=construccion" className="text-gray-500 hover:text-[#0056b3]" data-id="element-142">
                  Construcción
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-143">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-144">Contacto</h3>
            <ul className="space-y-3 text-sm" data-id="element-145">
              <li className="flex items-start gap-2 text-gray-500" data-id="element-146">
                <MapPin className="w-4 h-4 text-[#0056b3] mt-0.5 flex-shrink-0" data-id="element-147" />
                <span data-id="element-148">Caracas, Venezuela</span>
              </li>
              <li className="flex items-center gap-2 text-gray-500" data-id="element-149">
                <Phone className="w-4 h-4 text-[#0056b3] flex-shrink-0" data-id="element-150" />
                <span data-id="element-151">+58 412-4279146</span>
              </li>
              <li className="flex items-center gap-2 text-gray-500" data-id="element-152">
                <Mail className="w-4 h-4 text-[#0056b3] flex-shrink-0" data-id="element-153" />
                <span data-id="element-154">ventas@materialesbrasil.com</span>
              </li>
              <li className="flex items-center gap-2 text-gray-500" data-id="element-155">
                <Clock className="w-4 h-4 text-[#0056b3] flex-shrink-0" data-id="element-156" />
                <span data-id="element-157">Lun - Sáb: 8:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t" data-id="element-158">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-400" data-id="element-159">
          <p data-id="element-160">© 2024 Materiales Brasil, C.A. Todos los derechos reservados.</p>
          <div className="flex gap-4" data-id="element-161">
            <a href="#" className="hover:text-gray-600" data-id="element-162">
              Términos
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-163">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}